<div class="ap-flex-wrap">
    <ap-icon-button-link data-testid="loanToValueCal" apAnalyticsClick iconName="calculator" (click)="openModal()">{{
        'button.loan-to-value.text' | apContent
    }}</ap-icon-button-link>
    @if (showNotification) {
        <div class="ap-margin-top-4">
            <ap-notification status="error" [closeable]="true" (closeClicked)="resetNotification()">{{
                'notification.loan-to-value.text' | apContent
            }}</ap-notification>
        </div>
    }
</div>
